module.exports = __webpack_public_path__ + "static/img/2076379033_414975450_-213256083.e145c8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2076379033_414975450_-213256083.jpg
// module id = B107
// module chunks = 73